import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import homeService from './homeService'

const initialState = {
	homeImages: [],
	isError: false,
	isSuccess: false,
	isLoading: false,
	message: '',
}

export const getHomeImages = createAsyncThunk('images/getHomeImages', async (thunkAPI) => {
	try {
		return await homeService.getHomeImages()
	} catch (error) {
		const message =
			(error.response && error.response.data && error.response.data.message) ||
			error.message ||
			error.toString()

		return thunkAPI.rejectWithValue(message)
	}
})

export const homeSlice = createSlice({
	name: 'homeImages',
	initialState,
	reducers: {},
	extraReducers: (builder) => {
		builder
			.addCase(getHomeImages.pending, (state) => {
				state.isLoading = true
			})
			.addCase(getHomeImages.fulfilled, (state, action) => {
				state.isLoading = false
				state.isSuccess = true
				state.homeImages = action.payload
			})
			.addCase(getHomeImages.rejected, (state, action) => {
				state.isLoading = false
				state.isSuccess = false
				state.isError = true
				state.homeImages = []
				state.message = action.payload
			})
	},
})

export default homeSlice.reducer
